<template>
  <v-container fluid class="my-5 mx-0 pa-0">
    <v-card style="width: 100%" class="pa-6" elevation="0">
      <!-- Department Filter -->
      <div class="mb-4">
        <v-select
          v-model="selectedDepartment"
          :items="departmentOptions"
          :label="$t('history.elements.details.timelines.filterByDepartment')"
          outlined
          dense
          @change="onDepartmentChange"
        ></v-select>
      </div>

      <!-- Activities List -->
      <div
        v-for="(activity, index) in filteredActivities"
        :key="index"
        class="activity-content"
      >
        <div class="activity-body">
          <v-img
            max-height="90"
            max-width="90"
            :src="getImagePath(activity.event)"
          ></v-img>
          <p class="activity-description my-0 mx-2">
            {{ activity.description }}
          </p>
        </div>
        <div class="activity-timestamp text-body-2 color-disabled">
          {{ formatDate(activity.date) }}
        </div>
      </div>
    </v-card>
  </v-container>
</template>

<script>
import * as Sentry from "@sentry/vue";
import moment from "moment";
import fullProject from "@/api/fullProject";
import {
  ACTIVE_DEPARTMENTS,
  getActiveDepartmentOptions,
} from "@/constants/departments.js";
export default {
  name: "TimeLine",
  data() {
    return {
      activitiesByDepartment: {},
      selectedDepartment: "",
      departmentOptions: [],
    };
  },
  computed: {
    filteredActivities() {
      if (this.selectedDepartment === "all") {
        return Object.values(this.activitiesByDepartment)
          .flat()
          .sort((a, b) => new Date(b.date) - new Date(a.date));
      }
      return this.activitiesByDepartment[this.selectedDepartment] || [];
    },
  },
  methods: {
    async getActivities() {
      try {
        const response = await fullProject.fetchActivity(this.$route.params.id);
        if (response.code === 200) {
          // La nueva estructura es un diccionario de listas
          this.activitiesByDepartment = response.data.activity;
        }
      } catch (error) {
        Sentry.captureException(error);
      }
    },
    formatDate(dateString) {
      const date = moment(dateString, "ddd, DD MMM YYYY HH:mm:ss [GMT]");
      const formattedDate = date.format("hh:mm A - MM / DD / YYYY");
      return formattedDate;
    },
    getImagePath(event) {
      const eventToImagePath = {
        "Claim Created": require("@/assets/dashboard/claim.svg"),
        "File Uploaded": require("@/assets/dashboard/files.svg"),
        "Contacts Updated": require("@/assets/dashboard/workers.svg"),
        Comments: require("@/assets/dashboard/comment.svg"),
        Payment: require("@/assets/dashboard/payment.svg"),
      };
      return eventToImagePath[event] || require("@/assets/dashboard/claim.svg");
    },
    setDepartmentOptions() {
      this.departmentOptions = [
        {
          text: this.$t("history.elements.details.timelines.allDepartments"),
          value: "all",
        },
        ...getActiveDepartmentOptions(
          this.$t.bind(this),
          "history.elements.details.timelines",
        ),
      ];
    },
    setDefaultDepartment() {
      const userDepartment = this.$store.getters.getUser.department;

      if (userDepartment && ACTIVE_DEPARTMENTS.includes(userDepartment)) {
        this.selectedDepartment = userDepartment;
      } else {
        this.selectedDepartment = "all";
      }
    },
    onDepartmentChange() {
      // Método para manejar cambios en el filtro si es necesario
      // Por ahora solo se actualiza automáticamente con el computed
    },
  },
  async mounted() {
    await this.getActivities();
    this.setDepartmentOptions();
    this.setDefaultDepartment();
  },
  watch: {
    "$i18n.locale": function () {
      this.setDepartmentOptions();
    },
  },
};
</script>

<style scoped>
.activity-content {
  border: 1px solid #b5c0cc;
  border-radius: 12px;
  margin-bottom: 1.5rem;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
}

.activity-content:not(:first-child)::before {
  content: "";
  position: absolute;
  top: -1.5rem;
  left: 50%;
  width: 1px;
  height: 1.5rem;
  background-color: #b5c0cc;
}

.activity-body {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
}

.activity-description {
  flex: 1;
  min-width: 0;
  word-break: break-word;
}

.activity-timestamp {
  flex-shrink: 0;
  width: 14rem;
  white-space: nowrap;
  text-align: right;
}

.color-disabled {
  color: #a09d9d;
}
</style>
